import {
  LicensePlateData,
  LicensePlateVinLookupMethods,
  VINData,
} from "../reducers/reducer-license-plate-vin-lookup";
import {
  ResponseRecords,
  VehicleData
} from "../screens/AddVehicle/AddVehicleByLicensePlateVin/AddVehicleTypes";

export const CHANGE_LOOKUP_TYPE_METHOD =
  "@@LICENSE-PLATE-VIN-LOOKUP/CHANGE_LOOKUP_TYPE_METHOD" as const;
export const SET_LICENSE_PLATE =
  "@@LICENSE-PLATE-VIN-LOOKUP/SET_LICENSE_PLATE" as const;
export const SET_VIN = "@@LICENSE-PLATE-VIN-LOOKUP/SET_VIN" as const;
export const SEARCH_BY_VIN = "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN" as const;
export const SEARCH_BY_VIN_SUCCESS =
  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN_SUCCESS" as const;
export const SEARCH_BY_VIN_FAILED =
  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN_FAILED" as const;
export const SEARCH_BY_LICENSE_PLATE =
  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE" as const;
export const SEARCH_BY_LICENSE_PLATE_SUCCESS =
  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE_SUCCESS" as const;
export const SEARCH_BY_LICENSE_PLATE_ERROR =
  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE_ERROR" as const;
export const SELECT_VEHICLE = "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE" as const;
export const SELECT_VEHICLE_COLOR =
  "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE_COLOR" as const;
export const SELECT_VEHICLE_FUEL_TYPE =
  "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE_FUEL_TYPE" as const;
export const ADD_VEHICLE = "@@LICENSE-PLATE-VIN-LOOKUP/ADD_VEHICLE" as const;
export const RESET_SEARCH_RESULTS = "@@LICENSE-PLATE-VIN-LOOKUP/RESET_SEARCH_RESULTS" as const;
export const RESET_VIN_SEARCH_RESULTS = "@@LICENSE-PLATE-VIN-LOOKUP/RESET_VIN_SEARCH_RESULTS" as const;

export const changeLookupTypeMethod = (payload: LicensePlateVinLookupMethods) =>
  ({
    type: CHANGE_LOOKUP_TYPE_METHOD,
    payload,
  } as const);

export const setLicensePlate = (payload: LicensePlateData) =>
  ({
    type: SET_LICENSE_PLATE,
    payload,
  } as const);

export const setVin = (payload: VINData) =>
  ({
    type: SET_VIN,
    payload,
  } as const);

export const searchByVIN = (payload: VINData) =>
  ({
    type: SEARCH_BY_VIN,
    payload,
  } as const);

// Determine this type
export const searchByVINSuccess = (payload: ResponseRecords[]) =>
  ({
    type: SEARCH_BY_VIN_SUCCESS,
    payload,
  } as const);

// Determine this type
export const searchByVINFailed = (payload: any) =>
  ({
    type: SEARCH_BY_VIN_FAILED,
    payload,
  } as const);

export const searchByLicensePlate = (payload: LicensePlateData) =>
  ({
    type: SEARCH_BY_LICENSE_PLATE,
    payload,
  } as const);

// Determine this type
export const searchByLicensePlateSuccess = (payload: ResponseRecords[]) =>
  ({
    type: SEARCH_BY_LICENSE_PLATE_SUCCESS,
    payload,
  } as const);

// Determine this type
export const searchByLicensePlateError = (payload: any) =>
  ({
    type: SEARCH_BY_LICENSE_PLATE_ERROR,
    payload,
  } as const);

export const selectVehicle = (payload: VehicleData) => ({
  type: SELECT_VEHICLE,
  payload,
} as const);

export const selectVehicleColor = (payload: string) => ({
  type: SELECT_VEHICLE_COLOR,
  payload,
} as const);

export const selectVehicleFuelType = (payload: any) => ({
  type: SELECT_VEHICLE_FUEL_TYPE,
  payload,
} as const);

export const addVehicle = () => ({
  type: ADD_VEHICLE,
} as const);

export const resetSearchResults = () => ({
  type: RESET_SEARCH_RESULTS,
} as const);

export const resetVinSearchResult = () =>
  ({
    type: RESET_VIN_SEARCH_RESULTS,
  } as const);

export type LicensePlateVinLookupActions =
  | ReturnType<typeof changeLookupTypeMethod>
  | ReturnType<typeof setLicensePlate>
  | ReturnType<typeof setVin>
  | ReturnType<typeof searchByVIN>
  | ReturnType<typeof searchByVINSuccess>
  | ReturnType<typeof searchByVINFailed>
  | ReturnType<typeof searchByLicensePlate>
  | ReturnType<typeof searchByLicensePlateSuccess>
  | ReturnType<typeof searchByLicensePlateError>
  | ReturnType<typeof selectVehicle>
  | ReturnType<typeof selectVehicleColor>
  | ReturnType<typeof selectVehicleFuelType>
  | ReturnType<typeof addVehicle>
  | ReturnType<typeof resetSearchResults>
  | ReturnType<typeof resetVinSearchResult>;
